import {
  StringKeys,
  Exercise,
  ExerciseAttempt,
  ExerciseTest,
  ExerciseTestStatus,
  ExerciseSolution,
} from '../../types'

interface ObjectStringRef {
  [key: string]: string
}

interface ExercisesState extends StringKeys {
  currentExercise: Exercise | ObjectStringRef
  previousAttempts: Array<ExerciseAttempt>
  currentAttempt: ExerciseAttempt | ObjectStringRef
  currentTests: Array<ExerciseTest>
  currentTestsStatus: {
    [key: string]: ExerciseTestStatus
  }
  currentSolutions: Array<ExerciseSolution>
  currentFiles: ObjectStringRef
  currentOutput: string
  studentCodes: ObjectStringRef
  currentFlavor: string
}

const state: ExercisesState = {
  currentExercise: {},
  previousAttempts: [],
  currentAttempt: {},
  currentTests: [],
  currentTestsStatus: {},
  currentSolutions: [],
  currentFiles: {},
  currentOutput: '',
  studentCodes: {},
  currentFlavor: 'ds-3.8',
}

export { ExercisesState, state }
